var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "templatePicker" }, [
    _vm.categories.length && _vm.showCategories
      ? _c(
          "ul",
          { staticClass: "categories" },
          _vm._l(_vm.categories, function (category) {
            return _c(
              "li",
              {
                key: category.id,
                class: [
                  category.class,
                  { active: category.id == _vm.categoryId },
                ],
                on: {
                  click: function ($event) {
                    return _vm.selectCategory(category.id)
                  },
                },
              },
              [_vm._v("\n\t\t\t" + _vm._s(category.name) + "\n\t\t")]
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "ul",
      { ref: "picker", staticClass: "picker two" },
      _vm._l(_vm.templateSets, function (templateSet) {
        return _c("TemplatePickerItemView", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.filteredTemplateSets.indexOf(templateSet) > -1,
              expression: "filteredTemplateSets.indexOf(templateSet) > -1",
            },
          ],
          key: templateSet.id,
          staticClass: "pickerItem",
          attrs: {
            "template-set": templateSet,
            "page-width": _vm.pageWidth,
            "page-height": _vm.pageHeight,
            "max-width": _vm.maxItemWidth,
            "max-height": _vm.maxItemHeight,
            "page-background-color":
              _vm.templateSetId == templateSet.id ? "#ccc" : "#f1efeb",
            "default-text": _vm.defaultText,
          },
          on: { selectTemplate: _vm.selectTemplate },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }